// extracted by mini-css-extract-plugin
export default {"AsideDefault":"Aside_AsideDefault__EIM5d"};